import Effects from 'Effects';
import {bulkUpdate} from 'utils/bulkUpdate.js';
import Tone from 'tone';
import {AudioParamPercentageValueParameter,
        AudioParamValueParameter} from 'parameters/AbstractAudioParamParameter.js';
import HasTrack from './HasTrack.js';
        
export default class TransientShaper extends Effects.Effect {
    constructor(sequencerEngine) {
        super('Transient Shaper', () => new Tone.Gain(1), sequencerEngine); 
        this.effectNode.gain.value = 1;
        this.follower1 = new Tone.Follower();

        this.follower2 = new Tone.Follower();
        this.filter = new Tone.Filter(100, "highpass");
        this.effectNode.connect(this.filter);
        this.filter.connect(this.follower1);
        this.filter.connect(this.follower2);

        this.roughness1Parameter = new AudioParamValueParameter(
            'roughness1', this.follower1._filter.frequency,
            {
                defaultValue: 63.8,
                min: 0.01,
                max: 100,
                noInput: true
            });

        this.roughness2Parameter = new AudioParamValueParameter(
            'roughness2', this.follower2._filter.frequency,
            {
                defaultValue: 2.4,
                min: 0.01,
                max: 100,
                noInput: true
            });

        this.registerParameter(this.roughness1Parameter);
        this.registerParameter(this.roughness2Parameter);

        this.controlVoltage = new Tone.Subtract();
        this.follower1.connect(this.controlVoltage, 0, 0);
        this.follower2.connect(this.controlVoltage, 0, 1);

        this.input = this.effectNode;
        this.outputNode = new Tone.Gain(1);
        this.sustainNode = new Tone.Gain(1);

        this.effectNode.connect(this.sustainNode);
        this.sustainNode.connect(this.outputNode);

        this.controlVoltage.connect(this.sustainNode.gain);

        this.attackParameter= new AudioParamValueParameter(
            'attack', this.controlVoltage.output.gain,
            {
                defaultValue: 1,
                min: -4,
                max: 4,
                automationRate: "A_RATE"
            });

        this.registerParameter(this.attackParameter);
 
        this.outputGainParameter= new AudioParamValueParameter(
            'outputGain', this.outputNode.gain,
            {
                defaultValue: 1,
                min: 0,
                max: 2,
                automationRate: "A_RATE"
            });

        this.registerParameter(this.outputGainParameter);

        this.sustainParameter= new AudioParamValueParameter(
            'sustain', this.sustainNode.gain,
            {
                defaultValue: 0,
                min: 0,
                max: 0.5,
                automationRate: "A_RATE"
            });

        this.registerParameter(this.sustainParameter);
        this.updateInitialValues();
   }

    connect(a) {
        this.outputNode.connect(a);
        this.connectedNode = a;
    }

    disconnect(a) {
        this.outputNode.disconnect();
        this.connectedNode = null;
    }

    getJson(isPreset) {
        let json = {
            ... super.getJson(isPreset),
            attack: this.attackParameter.get(true),
            outputGain: this.outputGainParameter.get(true),
            sustain: this.sustainParameter.get(true),

        };
        json = this.saveParameterToJson(json, 'attackParameter', this.attackParameter);
        json = this.saveParameterToJson(json, 'outputGainParameter', this.outputGainParameter);
        json = this.saveParameterToJson(json, 'sustainParameter', this.sustainParameter);
        return json;
    }

    fromJson(json, isCopy) {
        let bulk = super.fromJson(json, isCopy);
        if (Tone.Master.context.isOffline) {
            bulkUpdate(this.attackParameter, json.attack, bulk);
            bulkUpdate(this.sustainParameter, json.sustain, bulk);
            bulkUpdate(this.outputGainParameter, json.outputGain, bulk);
        } else {
            setTimeout(() => {
                bulkUpdate(this.attackParameter, json.attack, bulk);
                bulkUpdate(this.sustainParameter, json.sustain, bulk);
                bulkUpdate(this.outputGainParameter, json.outputGain, bulk);
            }, 1000);
        }
        return {
            ... bulk,
            ... this.loadParameterFromJson(json, 'attackParameter', this.attackParameter, isCopy),
            ... this.loadParameterFromJson(json, 'sustainParameter', this.sustainParameter, isCopy),
            ... this.loadParameterFromJson(json, 'outputGainParameter', this.outputGainParameter, isCopy)
        };
    }

    getEffectCopy(sequencerEngine, ignoreId=true) {
        let fx = new TransientShaper(sequencerEngine);
        fx.fromJson(this.getJson(), ignoreId);
        return fx;
    }
}
 
